import { Button } from "@sellar-io/components";
import dayjs from "dayjs";
import { ReactElement } from "react";
import { SpinnerLegacy } from "../../components";
import { Alert } from "../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useCollectionUpdate } from "../../hooks/api/v2/collections/useCollectionUpdate";

export function CancelCollectionDialog({
  active,
  collectionId,
  onDismiss,
  collectionDate,
}: {
  active: boolean;
  collectionId: number;
  collectionDate: Date;
  onDismiss: () => void;
}): ReactElement {
  const cancelCollectionMutation = useCollectionUpdate(collectionId);
  const cancel = () => {
    cancelCollectionMutation.mutate(
      {
        cancelledAt: new Date(),
      },
      { onSuccess: () => onDismiss() },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={`Cancel collection for ${dayjs(collectionDate).format(
          "dddd DD MMMM",
        )}?`}
        description={"Are you sure you want to cancel this collection?"}
      />
      <DialogContent>
        {cancelCollectionMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(cancelCollectionMutation.error)?.response?.data
                .message ?? "An unknown error occurred"
            }
          />
        ) : (
          <>{cancelCollectionMutation.isPending && <SpinnerLegacy />}</>
        )}
      </DialogContent>
      <DialogCTA>
        <Button color={"red"} onClick={cancel}>
          Cancel collection
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
